import React from "react";
import {useTranslation} from "react-i18next";

function Footer() {
    const {t} = useTranslation()
    return (
        <div className="text-center ">
            <br></br>
            <h10 style={{color: '#6f7580'}}>{t('footer_text')}</h10>
        </div>
    );
}

export default Footer;